<div
  id="teams"
  class="page-layout blank"
  class="page-layout simple"
  fxLayout="column">
  <!-- HEADER -->
  <div class="header-users">
    <div class="header-container">
      <div
        class="name field"
        [@animate]="{ value: '*', params: { delay: '100ms', x: '-25px' } }">
        {{ 'DELETED-TEAMS-PAGE.TITLE' | translate }}
      </div>
      <div class="button-section">
        <button
          mat-icon-button
          (click)="reloadTeams()"
          aria-label="refresh"
          class="export-btn search-button-action">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>
    </div>
    <div class="search-section">
      <div class="search-field" [@fadeInOut]>
        <div class="search-wrapper">
          <div
            class="search"
            fxFlex
            fxLayout="row"
            fxLayoutAlign="start center">
            <mat-icon>search</mat-icon>
            <input
              autoComplete="on"
              #filter
              [formControl]="teamsNameFilter"
              matInput
              placeholder="{{
                'DELETED-TEAMS-PAGE.SEARCH-NAME-FIELD' | translate
              }}" />
          </div>
        </div>
      </div>
      <div class="search-field" [@fadeInOut]>
        <div class="search-wrapper">
          <div
            class="search"
            fxFlex
            fxLayout="row"
            fxLayoutAlign="start center">
            <mat-icon>search</mat-icon>
            <input
              autoComplete="on"
              #filter
              [formControl]="teamsMailFilter"
              matInput
              placeholder="{{
                'DELETED-TEAMS-PAGE.SEARCH-MAIL-FIELD' | translate
              }}" />
          </div>
        </div>
      </div>
      <div class="search-field" [@fadeInOut]>
        <div class="search-wrapper date-range">
            <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [min]="minDate" [max]="maxDate">
              <input matStartDate placeholder="Start date" formControlName="start" (dateChange)="onStartDateChange($event)">
              <input matEndDate placeholder="End date" formControlName="end" (dateChange)="onEndDateChange($event)">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </div>
      </div>
        
    </div>
  </div>
  <!-- / HEADER -->
  <div class="content-card" fxFill>
    @if (isLoading) {
      <mat-progress-bar
        color="accent"
        mode="indeterminate"
        class="mat-progress-bar">
      </mat-progress-bar>
    }
    <div class="content">
      <div class="row wrap">
        <div class="message-box info">
          <div>{{ 'DELETED-TEAMS-PAGE.DELETED-TEAMS-INFO' | translate }}</div>
        </div>
      </div>
      <div class="row general-content">
        @if (dataSourceTeams && dataSourceTeams.data.length > 0 && !isLoading) {
          <table
            mat-table
            [dataSource]="dataSourceTeams"
            multiTemplateDataRows
            matSort>
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  (change)="$event ? toggleAllRows() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row" class="mat-column-select">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)">
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="timeDeletion">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'TABLE.USERS.HEADER.STATUS' | translate }}
              </th>
              <td
                mat-cell
                class="mat-column-timeDeletion"
                *matCellDef="let team">
                <div class="status">
                  <mat-icon
                    [matTooltip]="
                      'DELETED-TEAMS-PAGE.TEAM-DELETION'
                        | translate
                          : {
                              days: getDaysBeforeDeletion(
                                team.permanentlyDeletedDateTime
                              ),
                            }
                    "
                    [ngClass]="
                      getDeletionClass(team.permanentlyDeletedDateTime)
                    "
                    >warning</mat-icon
                  >
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="photo">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell class="mat-column-photo" *matCellDef="let team">
                <img
                  src="../../../../../assets/images/maintenance/services/TEAMS.svg"
                  class="serviceImage"
                  alt="{{ 'GENERAL.SERVICE_IMAGE' | translate }}" />
              </td>
            </ng-container>

            <ng-container matColumnDef="displayName">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'DELETED-TEAMS-PAGE.NAME' | translate }}
              </th>
              <td mat-cell *matCellDef="let team">{{ team.displayName }}</td>
            </ng-container>

            <ng-container matColumnDef="mail">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'DELETED-TEAMS-PAGE.MAIL' | translate }}
              </th>
              <td mat-cell *matCellDef="let team">{{ team.mail }}</td>
            </ng-container>

            <ng-container matColumnDef="deletedDateTime">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'DELETED-TEAMS-PAGE.DELETED-TIME' | translate }}
              </th>
              <td mat-cell *matCellDef="let team">
                {{ team.deletedDateTime | date: 'dd/MM/yyyy hh:mm' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="daysBeforeDeletion">
              <th mat-header-cell *matHeaderCellDef class="sortable">
                {{ 'DELETED-TEAMS-PAGE.TIME-REMAINING' | translate }}
              </th>
              <td mat-cell *matCellDef="let team">
                {{ getDaysBeforeDeletion(team.permanentlyDeletedDateTime) }}
                {{ 'DELETED-TEAMS-PAGE.DAYS' | translate }}
              </td>
            </ng-container>

            <ng-container matColumnDef="restore">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let team">
                <div class="action" fxLayout="row" fxLayoutAlign="start center">
                  <button mat-button (click)="openRestoreTeamDialog(team)">
                    <mat-icon class="restore-team">cloud_upload</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="expand">
              <th mat-header-cell *matHeaderCellDef aria-label="row actions">
                &nbsp;
              </th>
              <td mat-cell *matCellDef="let team">
                <button
                  mat-icon-button
                  aria-label="expand row"
                  (click)="
                    expandedTeam = expandedTeam === team ? null : team;
                    $event.stopPropagation()
                  ">
                  <mat-icon>more_horiz</mat-icon>
                </button>
              </td>
            </ng-container>

            <ng-container matColumnDef="expandedDetail">
              <td
                mat-cell
                *matCellDef="let team"
                [attr.colspan]="displayedColumnsTeams.length">
                <div class="team-detail">
                  @if (hiddenColumns.includes('timeDeletion')) {
                    <div class="team-column">
                      <div class="title">
                        {{ 'TABLE.USERS.HEADER.STATUS' | translate }} :
                      </div>
                      <div class="status">
                        <mat-icon
                          [matTooltip]="
                            'DELETED-TEAMS-PAGE.TEAM-DELETION'
                              | translate
                                : {
                                    days: getDaysBeforeDeletion(
                                      team.permanentlyDeletedDateTime
                                    ),
                                  }
                          "
                          [ngClass]="
                            getDeletionClass(team.permanentlyDeletedDateTime)
                          "
                          >warning</mat-icon
                        >
                      </div>
                    </div>
                  }
                  @if (hiddenColumns.includes('mail')) {
                    <div class="team-column">
                      <div class="title">
                        {{ 'DELETED-TEAMS-PAGE.MAIL' | translate }} :
                      </div>
                      <div class="content">{{ team.mail }}</div>
                    </div>
                  }
                  @if (hiddenColumns.includes('deletedDateTime')) {
                    <div class="team-column">
                      <div class="title">
                        {{ 'DELETED-TEAMS-PAGE.DELETED-TIME' | translate }} :
                      </div>
                      <div class="content">{{ team.deletedDateTime }}</div>
                    </div>
                  }
                  @if (hiddenColumns.includes('restore')) {
                    <div class="team-column">
                      <div
                        class="action"
                        fxLayout="row"
                        fxLayoutAlign="start center">
                        <button
                          mat-button
                          color="accent"
                          class="access-btn"
                          (click)="openRestoreTeamDialog(team)">
                          <mat-icon>restore_from_trash</mat-icon>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumnsTeams"></tr>
            <tr
              mat-row
              *matRowDef="let team; columns: displayedColumnsTeams"></tr>
            <tr
              mat-row
              *matRowDef="let team; columns: ['expandedDetail']"
              [class.show-hide]="expandedTeam !== team"></tr>
          </table>
        }
        <div [hidden]="isLoading || hidePagination">
          <mat-paginator
            class="paginator"
            [length]="contextStorage.length"
            [pageSize]="contextStorage.pageSize"
            [pageIndex]="contextStorage.pageIndex"
            (page)="onPage($event)"
            [hidePageSize]="true">
          </mat-paginator>
        </div>

        @if (dataSourceTeams && dataSourceTeams.data.length === 0) {
          <h1 class="no-item">
            {{ 'DELETED-TEAMS-PAGE.NO-DELETED-TEAMS' | translate }}
          </h1>
        }
      </div>
    </div>
  </div>
</div>
